module.exports = "/_next/static/images/apple-icon-76x76-88664c0df39785b5dda834815933e1f5.png";